// extracted by mini-css-extract-plugin
export default {"content":"styles_content__p1awr","loadingCtn":"styles_loadingCtn__iapYK","loading":"styles_loading__gmDZ+","spin":"styles_spin__42W+T"};